import { useEffect, useState } from 'react';
import { Admin, Resource, CustomRoutes, DataProvider } from 'react-admin';
import { Route } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import DescriptionIcon from '@mui/icons-material/Description';
import PaymentsIcon from '@mui/icons-material/Payments';
import StoreIcon from '@mui/icons-material/Store';
import { buildDataProvider } from './dataProvider';
import { i18nProvider } from './i18nProvider';
import { lightTheme, darkTheme } from './theme';
import { MyLayout } from './layout';
import { Dashboard } from './pages/Dashboard';
import { SettingsPage } from './pages/SettingsPage';
import { DebtSlipList, DebtSlipEdit, DebtSlipCreate } from './resources/debtSlips';
import { VatInvoiceList, VatInvoiceEdit, VatInvoiceCreate } from './resources/vatInvoices';
import { PaymentOrderList, PaymentOrderEdit } from './resources/paymentOrders';
import { SupplierList, SupplierEdit, SupplierCreate } from './resources/suppliers';

export default function App() {
  const [dataProvider, setDataProvider] = useState<DataProvider | null>(null);

  useEffect(() => {
    buildDataProvider().then(setDataProvider);
  }, []);

  if (!dataProvider) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
        <Box sx={{ display: 'grid', justifyItems: 'center', gap: 1.5 }}>
          <CircularProgress size={34} />
          <Typography color="text.secondary">Đang tải dữ liệu…</Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Admin
      dataProvider={dataProvider}
      i18nProvider={i18nProvider}
      dashboard={Dashboard}
      layout={MyLayout}
      theme={lightTheme}
      darkTheme={darkTheme}
      defaultTheme="light"
      title="AI Quản Lý Công Nợ"
    >
      <Resource
        name="debtSlips"
        options={{ label: 'Đơn nợ' }}
        list={DebtSlipList}
        edit={DebtSlipEdit}
        create={DebtSlipCreate}
        icon={ReceiptLongIcon}
      />
      <Resource
        name="vatInvoices"
        options={{ label: 'Hóa đơn VAT' }}
        list={VatInvoiceList}
        edit={VatInvoiceEdit}
        create={VatInvoiceCreate}
        icon={DescriptionIcon}
      />
      <Resource
        name="paymentOrders"
        options={{ label: 'Lệnh chi' }}
        list={PaymentOrderList}
        edit={PaymentOrderEdit}
        icon={PaymentsIcon}
      />
      <Resource
        name="suppliers"
        options={{ label: 'Nhà cung cấp' }}
        list={SupplierList}
        edit={SupplierEdit}
        create={SupplierCreate}
        icon={StoreIcon}
      />
      <CustomRoutes>
        <Route path="/settings" element={<SettingsPage />} />
      </CustomRoutes>
    </Admin>
  );
}
